$(document).ready(function () {
  document.querySelectorAll(".Slider__Button").forEach((e) => {
    e.addEventListener("click", toggleSlide);
  });
});

function toggleSlide() {
  let slider = document.getElementById("slider");
  let phoneContent = document.getElementById("phone");
  let calendarContent = document.getElementById("calendar");
  // console.log(slider.classList.contains("Slider--active"));
  if (slider.classList.contains("Slider--active")) {
    if (
      document
        .getElementById(this.dataset.content)
        .classList.contains("Slider__Content--active")
    ) {
      clearContent();
      slider.classList.toggle("Slider--active");
      document
        .getElementById("slider-intern")
        .classList.toggle("Slider__Wrapper--active");
    } else {
      clearContent();
      document
        .getElementById(this.dataset.content)
        .classList.add("Slider__Content--active");
    }
  } else {
    //open slider with correct content
    clearContent();
    slider.classList.toggle("Slider--active");
    document
      .getElementById("slider-intern")
      .classList.toggle("Slider__Wrapper--active");
    document
      .getElementById(this.dataset.content)
      .classList.add("Slider__Content--active");
  }
}

function clearContent() {
  document.querySelectorAll(".Slider__Content").forEach((e) => {
    e.classList.remove("Slider__Content--active");
  });
}
